import React from "react";
import Gallery from "../components/Gallery.js";
import EventItem from "../components/EventItem.js";
import styled from "styled-components";
import Thumbnail from "../components/Thumbnail";
import { ThumbnailContainer } from "../components/Thumbnail";
import { Link } from "react-router-dom";
import TextBlockOben from "../components/TextBlockOben.js";
const ContainerAll = styled.div`
  width: 100%;
  margin-top: 20px;
`;
const Termine = (props) => {
  return (
    <TextBlockOben>
      <h1>Termine</h1>
      <p>
        Wenn Ihr mich und meine Produkte einmal vor Ort kennenlernen möchtet,<br />
        dann freue ich mich auf Euren Besuch an meinem Stand.
      </p>
      <ThumbnailContainer width={320}>
        <Thumbnail title="" src={require("../images/Stand_TL.jpg")} />
      </ThumbnailContainer>
        <h2>März 2026</h2>
        <EventItem
          year="März 2026"
          days="14.03. - 15.03."
          text="Frühjahrsmarkt im Freilichtmuseum am Kiekeberg, 21224 Rosengarten"
        />
        <h2>März 2026</h2>
        <EventItem
          year="März 2026"
          days="21.03. - 22.03."
          text="Ostermarkt des Kunsthandwerks - Museum im Marstall, Schlossplatz 11, Winsen(Luhe)"
        />
        <h2>Mai 2026</h2>
        <EventItem
          year="Mai 2026"
          days="14.05."
          text="Kunsthandwerkermarkt am Rantzauer See, 25355 Barmstedt"
        />
        <h2>Mai 2026</h2>
        <EventItem
          year="Mai 2026"
          days="24.05."
          text="Schaftag auf dem Museumshof Lensahn, 23738 Lensahn"
        />
        <h2>Juni 2026</h2>
        <EventItem
          year="Juni 2026"
          days="06.06. - 07.06."
          text="Mittelaltermarkt Ascheberg, 24326 Ascheberg"
        />
        <EventItem
          year="Juni 2026"
          days="13.06. - 14.06."
          text="Kunst- und Kreativmarkt Kellenhusen, 23746 Kelenhusen"
        />
        <h2>Juli 2026</h2>
        <EventItem
          year="Juli 2026"
          days="04.07. - 05.07."
          text="Fantasy und Mittelalter-Fest zu Wahlstedt - mit Kunsthandwerkermarkt, Schützenplatz Wahlstedt, Scharnhorststraße 49"
        />
        <h2>August 2026</h2>
        <EventItem
          year="August 2026"
          days="22.08. - 23.08."
          text="Kunsthandwerkermarkt Allmende Wulfsdorf, Bornkampsweg 36, 22926 Ahrensburg"
        />
        <h2>Oktober 2026</h2>
        <EventItem
          year="Oktober 2026"
          days="03.10. - 07.10."
          text="Herbstmarkt im Freilichtmuseum Molfsee, Hamburger Landstraße 97, 24113 Molfsee"
        />
        <h2>November 2026</h2>
        <EventItem
          year="November 2026"
          days="14.11."
          text="Martinsmarkt Freie Waldorfschule, 11:00 - 17:00 Uhr, Elmshorn"
        />
        <EventItem
          year="November 2026"
          days="27.11. - 29.11."
          text="Weihnachtsmarkt im Freilichtmuseum am Kiekeberg, Am Kiekeberg 1, 21224 Rosengarten-Ehestorf"
        />
      
      
      
    </TextBlockOben>
  );
};

export { Termine };
